
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { GetAddress, addrOTD } from '@/api/company'

@Component
export default class AreaPopup extends Vue {
  @Prop({default: ''}) defaulId?: string
  @Prop({default: ''}) defaulName?: string
  @Prop({default: ''}) title?: string


  @Watch('defaulId', {immediate: true})
  idChange () {
    this.addressId = this.defaulId
    this.getAddress('_top')
  }

  @Watch('popShow', {immediate: true})
  showChange (val) {
    if (val) {
      this.addressId = this.defaulId
      this.getAddress('_top')
    }
  }

  @Watch('defaulName', {immediate: true})
  nameChange () {
    this.addressName = this.defaulName
  }

  popShow = false

  addressName = '' // 收货地址 名称
  addressId = '' // 收货地址Id

  options = []

  fieldNames = {text: 'addressName', value: 'addressId', children: 'children'}

  onChange ({value, selectedOptions}) {
    GetAddress({parentId: value}).then(res => {
      let addrs: Array<addrOTD> = res.data
      if (value.length === 2) {
        addrs.map(item => {
          item.children = null
        })
        let index = this.options.findIndex((item) => item.addressId === value)
        this.options[index].children = addrs
      }
    })
  }

  getAddress (parentId: string) {
    GetAddress({parentId}).then(res => {
      let addrs: Array<addrOTD> = res.data
      addrs.map(item => {
        item.children = []
      })
      this.options = addrs
      this.options.unshift({
        addressName: '全部区域',
        addressId: ''
      })
    })
  }

  onFinish ({value, selectedOptions}) {
    this.popShow = false
    this.addressId = value
    this.addressName = selectedOptions.map((option) => option.addressName).join('')
    this.$emit('load', {addressId: this.addressId, addressName: this.addressName})
  }

  showPop () {
    this.popShow = true
  }
}
